// extracted by mini-css-extract-plugin
module.exports = {"control":"IconButtonsControl-module--control--105f17","button":"IconButtonsControl-module--button--7e6539"};